import "./VerifiedPendingKPI.css";

import { ProjectIssuanceConstants } from "../../../../constants";
import { formatNumber } from "../../../../utils";
import { GenericTooltip } from "../../../forms";

interface VerifiedPendingKPIProps {
  verifiedUnits: number;
  pendingUnits: number;
  standardUuid: string;
}

export const VerifiedPendingKPI = ({
  verifiedUnits,
  pendingUnits,
  standardUuid,
}: VerifiedPendingKPIProps): JSX.Element => {
  const total = verifiedUnits + pendingUnits;
  const verifiedRatio = (verifiedUnits / total) * 100;
  const pendingRatio = (pendingUnits / total) * 100;

  const unitTypes = ProjectIssuanceConstants.ISSUANCE_QUANTITY_TYPE_BY_STANDARD[standardUuid] ?? ["PIU", "VCU"];

  return (
    <div className="VerifiedPendingContainer">
      {verifiedUnits === 0 ? (
        <>
          <div className="VerifiedPendingGraph">
            <GenericTooltip
              placement="right"
              content={
                <div className="VerifiedPendingTooltipContainer">
                  <p className="body3">{`${pendingUnits} ${unitTypes[0]}s`}</p>
                </div>
              }
            >
              <div className="PendingGraphRowFilled" />
            </GenericTooltip>
            <GenericTooltip
              placement="right"
              content={
                <div className="VerifiedPendingTooltipContainer">
                  <p className="body3">{`${verifiedUnits} ${unitTypes[1]}s`}</p>
                </div>
              }
            >
              <div className="VerifiedGraphRowEmpty" />
            </GenericTooltip>
          </div>
          <div className="VerifiedPendingHeaderArea">
            <h2>{formatNumber(pendingUnits)}</h2>
            <p className="body2">Carbon Units</p>
            <p className="body3">{unitTypes[0]}s only</p>
          </div>
        </>
      ) : (
        <>
          <div className="VerifiedPendingGraph">
            <GenericTooltip
              placement="right"
              content={
                <div className="VerifiedPendingTooltipContainer">
                  <p className="body3">{`${pendingUnits} ${unitTypes[0]}s`}</p>
                </div>
              }
            >
              <div className="PendingGraphRowFilled" style={{ flex: pendingRatio }} />
            </GenericTooltip>
            <GenericTooltip
              placement="right"
              content={
                <div className="VerifiedPendingTooltipContainer">
                  <p className="body3">{`${verifiedUnits} ${unitTypes[1]}s`}</p>
                </div>
              }
            >
              <div className="VerifiedGraphRowFilled" style={{ flex: verifiedRatio }} />
            </GenericTooltip>
          </div>
          <div className="VerifiedPendingHeaderArea">
            <h2>{formatNumber(total)}</h2>
            <p className="body2">Carbon Units</p>
            <p className="body3">
              {unitTypes[0]}s and {unitTypes[1]}s
            </p>
          </div>
        </>
      )}
    </div>
  );
};
